import { API } from '../config';

export const getChartData = (url: string) =>
	fetch(`${API}/${url}`, {
		headers: {},
	})
		.then(res => res.json())
		.then(res => res);
